export class DataFilter {
    constructor(data) {
        this.filterData = [];
        this.dataCount = 0;
        this.iteration = 0;
        this.setData(data);
    }

    /**
     * Setter for data
     * @param data
     * @returns {DataFilter}
     */
    setData(data) {
        if (typeof data !== 'object' || typeof data === 'undefined') {
            this.data = [];
        } else {
            this.data = data;
        }

        this.dataCount = this.data.length;
        return this;
    }

    /**
     * Getter for data
     * @returns {Array|*}
     */
    getData() {
        return this.data;
    }

    /**
     * Resets the filter data
     * @returns {DataFilter}
     */
    resetFilterData() {
        this.filterData = [];
        return this;
    }

    /**
     * Registers a closure to be used for a specific filter
     * @param callback
     * @returns {DataFilter}
     */
    filter(callback) {
        if (typeof callback === 'function') {
            this.filterData.push(callback);
        }

        return this;
    }

    /**
     * Filters data by calling closures from the filterData and returns a Promise object
     * @returns {Promise<any>}
     */
    getFilteredData() {
        let self = this;

        return new Promise((resolve) => {
            self.filterData.forEach(function (callable, index) {
                self.setData(
                    self.getData().filter((item) => {
                        let found = false;
                        if (typeof callable === 'function') {
                            self.iteration += 1;
                            found = callable.call(self, item);
                        }
                        return found;
                    })
                );
            });

            this.resetFilterData();
            resolve(self.getData());
        });
    }
}
